import { render, staticRenderFns } from "./SpecialCoursePromptModal.vue?vue&type=template&id=2e0a258d&scoped=true"
import script from "./SpecialCoursePromptModal.vue?vue&type=script&lang=js"
export * from "./SpecialCoursePromptModal.vue?vue&type=script&lang=js"
import style0 from "./SpecialCoursePromptModal.vue?vue&type=style&index=0&id=2e0a258d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a258d",
  null
  
)

export default component.exports